import { CosmeticsHarmony } from "./profileCosmeticsHarmony"

/** Цвет ника — отдельный SKU. */

export type ProfileNicknameColorKey =
  | "ember_gold"
  | "ice_cyan"
  | "storm_violet"
  | "toxic_lime"
  | "rose_glow"
  | "pure_white"
  | "neon_yellow"
  | "ocean_blue"
  | "blood_red"
  | "mint_fresh"

export interface ProfileNicknameColorDef {
  key: ProfileNicknameColorKey
  title: string
  subtitle: string
  color: string
  harmony: CosmeticsHarmony
}

export const PROFILE_NICKNAME_COLORS: ProfileNicknameColorDef[] = [
  {
    key: "ember_gold",
    title: "Янтарный",
    subtitle: "Тёплый золотистый",
    color: "#FDBA74",
    harmony: "ember",
  },
  {
    key: "ice_cyan",
    title: "Ледяной",
    subtitle: "Бирюзовый холод",
    color: "#67E8F9",
    harmony: "ice",
  },
  {
    key: "storm_violet",
    title: "Грозовой",
    subtitle: "Фиолетовый неон",
    color: "#C4B5FD",
    harmony: "storm",
  },
  {
    key: "toxic_lime",
    title: "Ядовитый",
    subtitle: "Кислотный лайм",
    color: "#A3E635",
    harmony: "forest",
  },
  {
    key: "rose_glow",
    title: "Розовый",
    subtitle: "Мягкий glow",
    color: "#FDA4AF",
    harmony: "dusk",
  },
  {
    key: "pure_white",
    title: "Белый",
    subtitle: "Подходит почти ко всему",
    color: "#F8FAFC",
    harmony: "mist",
  },
  {
    key: "neon_yellow",
    title: "Неон",
    subtitle: "Ярко-лимонный",
    color: "#FDE047",
    harmony: "ember",
  },
  {
    key: "ocean_blue",
    title: "Океан",
    subtitle: "Глубокий синий",
    color: "#60A5FA",
    harmony: "tide",
  },
  {
    key: "blood_red",
    title: "Алый",
    subtitle: "Кровавый акцент",
    color: "#F87171",
    harmony: "magma",
  },
  {
    key: "mint_fresh",
    title: "Мята",
    subtitle: "Свежий зелёный",
    color: "#6EE7B7",
    harmony: "forest",
  },
]

export const PROFILE_NICKNAME_COLOR_BY_KEY: Record<
  ProfileNicknameColorKey,
  ProfileNicknameColorDef
> = PROFILE_NICKNAME_COLORS.reduce(
  (acc, item) => {
    acc[item.key] = item
    return acc
  },
  {} as Record<ProfileNicknameColorKey, ProfileNicknameColorDef>
)

export function isProfileNicknameColorKey(
  value: string
): value is ProfileNicknameColorKey {
  return value in PROFILE_NICKNAME_COLOR_BY_KEY
}

export function resolveProfileNicknameColor(
  key: string | null | undefined
): ProfileNicknameColorDef | null {
  if (!key || !isProfileNicknameColorKey(key)) return null
  return PROFILE_NICKNAME_COLOR_BY_KEY[key]
}
